import { render, staticRenderFns } from "./SeventhSection.vue?vue&type=template&id=a708c572&"
import script from "./SeventhSection.vue?vue&type=script&lang=ts&"
export * from "./SeventhSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports